const ROUTES = {
    LOGIN: '/login',

    DASHBOARD: '/dashboard',

    USERS: '/users',
    
    APPLICATION_SERVICES: '/application-services',
    ACCESS_KEYS: '/access-keys',

    PLANS: '/plans',
    PLAN_GROUPS: '/plan-groups'
}

export default ROUTES